(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
/* No JS needed; CSS handles desktop/mobile imagery without duplication. */

  } catch(e) { console.error(e); }
})();
})();
